import React from 'react';

import cx from 'classnames';

import useStyles from './styles';

interface ShareButtonProps {
  children: React.ReactNode;
  wrapperClass?: string;
  onClick?: () => void;
}

const ShareButton: React.FC<ShareButtonProps> = ({ children, wrapperClass, onClick, ...rest }) => {
  const classes = useStyles();

  return (
    <div onClick={onClick} className={cx(classes.wrapper, wrapperClass)} {...rest}>
      {children}
    </div>
  );
};

export default ShareButton;
